import Vue from 'vue'
import InfiniteScroll from './lib/InfiniteScroll'

Vue.component('InfiniteScroll', InfiniteScroll)